<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" right="iconadd" @rightClick="onAddNew" />
    <van-dropdown-menu>
      <van-dropdown-item v-model="search.isOnline" :options="optionState" @change="init" />
      <van-dropdown-item v-model="search.examId" :options="optionExam" @change="init" />
    </van-dropdown-menu>
    <div class="topEmptyRect" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.begin.beginId" class="examBeginRect" @click="onClickExam(item)">

        <van-row>
          <van-col span="8"><span>名称:</span> {{ item.exam.title }}</van-col>
          <van-col span="8"><span>开始:</span> {{ formatDate(item.begin.beginTime,"MM/dd hh:mm",true) }}</van-col>
          <van-col span="8"><span>结束:</span> {{ formatDate(item.begin.endTime,"MM/dd hh:mm",true) }}</van-col>
        </van-row>
        <van-row>
          <van-col span="8"><span>类型:</span> {{ item.exam.type }}</van-col>
          <van-col span="8"><span>时长:</span> {{ item.exam.timeMinute }}min</van-col>
          <van-col span="8"><span>剩余时间:</span>
            <van-count-down v-if="item.countDownTime>0" style="display: inline;" :time="item.countDownTime" />
            <van-tag v-if="item.countDownTime<=0" type="danger" style="color:#fff">已结束</van-tag>

          </van-col>
        </van-row>
        <van-row>
          <van-col span="6"><span>总计:</span> {{ item.userTotal }}</van-col>
          <van-col span="6"><span>进行中:</span> {{ item.userRunTotal }}</van-col>
          <van-col span="6"><span>未通过:</span> {{ item.userFalseTotal }}</van-col>
          <van-col span="6"><span>通过:</span> {{ item.userPassTotal }}</van-col>
        </van-row>
        <span>备注:</span> {{ item.begin.remark }}
      </div>
    </van-list>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, DropdownMenu, DropdownItem, List, CountDown, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [CountDown.name]: CountDown,
    [Tag.name]: Tag,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '测验列表',
      backurl: '/pro/index',
      search: {
        limit: 30,
        page: 1,
        isOnline: null,
        examId: undefined
      },
      loading: undefined,
      finished: false,
      list: [],
      optionExam: [],
      optionState: [
        { text: '不限结束', value: null },
        { text: '已结束', value: false },
        { text: '进行中', value: true }
      ]

    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.initExamList()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onAddNew() {
      this.$router.push('/pro/examAdd')
    },
    initExamList(callback) {
      this.optionExam = [{ value: undefined, text: '不限考试' }]
      request({
        url: '/DiveLearn/getExamList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        console.log('asd', response.data)
        response.data.forEach(item => {
          this.optionExam.push({
            value: item.examId,
            text: item.title + '[' + item.totalNum + '题]' })
        })
        if (callback) {
          callback()
        }
      })
    },
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      request({
        url: '/DiveLearn/getExamBeginList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onClickExam(row) {
      this.$router.push('/pro/examInfo/' + row.begin.beginId)
    }
  }
}
</script>
<style scoped>
.examBeginRect{
  background-color: #fff;
  padding: 0.5em 1em;
  font-size: 0.7em;
  border-bottom: 1px solid #f5f5f5;
}
.examBeginRect span{
  color: #999;
}

</style>
